module.exports = __webpack_public_path__ + "zyro-omsig.png?b80f4431795fbcb9a0ca1dd20ec0d00a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newsenviromental/zyro-omsig.png
// module id = 314
// module chunks = 0